import classNames from "classnames";

import Dot, { VARIANT } from "./Dot";
import {
  BatteryFullIcon,
  BatteryLowIcon,
  BatteryMediumIcon,
  BatteryWarningIcon,
} from "./Icons";

type Props = {
  isConnected: boolean;
  batteryValue: number;
  className?: string;
};

const getBatteryIcon = (batteryValue: number) => {
  if (batteryValue < 10) return <BatteryWarningIcon />;
  if (batteryValue < 30) return <BatteryLowIcon />;
  if (batteryValue < 60) return <BatteryMediumIcon />;
  return <BatteryFullIcon />;
};

const HeadsetStatus = ({ isConnected, batteryValue, className }: Props) => {
  const roundedBattery = Math.round(batteryValue);

  return (
    <div className={classNames("flex items-center gap-3", className)}>
      <div className="flex items-center">
        <Dot
          variant={isConnected ? VARIANT.SUCCESS : VARIANT.ERROR}
          className="px-0 pr-2"
        />
        <span>{isConnected ? "Conectado" : "Desconectado"}</span>
      </div>
      {isConnected && (
        <div className="flex items-center space-x-2 ml-1">
          {getBatteryIcon(roundedBattery)}
          <span className="w-14">{roundedBattery}%</span>
        </div>
      )}
    </div>
  );
};

export default HeadsetStatus;
